import { useContext } from "react";
import ThemeContext from "../../context/ThemeContext";

const DarkMode = () => {
  const { isDarkMode, actions } = useContext(ThemeContext);

  return (
    <div>
    
    </div>
  );
}

export default DarkMode;